import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../../../Shared/PageTitle/PageTitle";
import Devis from "./components/Devis/Devis";
import SliderImage from "./components/SliderImage/SliderImage";

import "./OtherDetails.css";

const OtherDetails = ({ data, title, currentPage, link }) => {
  // get the specified equipmentId and product Id
  const [selectedProduct, setselectedProduct] = useState({});
  const [selectedItem, setselectedItem] = useState({});
  const { selectedId, productId } = useParams();

  useEffect(() => {
    window.scrollTo(10, 0);
  }, []);

  useEffect(() => {
    console.log(selectedId, productId);
    // find the selected equipment
    let index = data.findIndex((eq) => eq.id.toString() === selectedId);
    if (index === -1) {
      return;
    }

    //find the selected product
    setselectedItem(data[index]);

    const selectedItem = data[index];
    index = selectedItem.products.findIndex(
      (pr) => pr.id.toString() === productId
    );
    if (index === -1) {
      return;
    }

    setselectedProduct(selectedItem.products[index]);
    console.log(selectedProduct);
  }, [productId, selectedId, selectedItem]);

  return (
    <>
      <PageTitle
        title={title}
        currentPage={currentPage}
        link={link}
        category={selectedItem.title}
        linkCategory={"single/" + selectedItem.id}
        detail={selectedProduct.name}
      />

      <section className="page-content">
        <div className="container">
          <div className="page-content-row">
            <div className="shop-page">
              <div className="row">
                <div className="col-lg-12">
                  <div className="shop-page-details section-padding">
                    <div className="shop-items">
                      <div className="shop-item single">
                        {/* image + description */}
                        <div className="row ">
                          <div className="col-lg-6">
                            <SliderImage data={selectedProduct.images} />
                          </div>
                          <div className="col-lg-6">
                            <div className="shop-info">
                              <h3 className="product-equipment-title">
                                {selectedProduct.name}
                              </h3>

                              <div className="clearfix"></div>

                              <div className="des product-equipment-description">
                                {/* RAMEZ STYLE */}
                                {selectedProduct &&
                                  selectedProduct.descriptionPoints &&
                                  selectedProduct.descriptionPoints.map(
                                    (desc) => (
                                      <p key={desc.description}>
                                        {desc.description}
                                      </p>
                                    )
                                  )}
                              </div>
                              <form>
                                <a
                                  href={selectedProduct.brochure}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn-style22"
                                >
                                  {"Télécharger Brochure"}
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>

                        {/* vid + fiche technique */}
                        <div
                          className="row vid-fiche-technique"
                          style={{ marginTop: "2rem" }}
                        >
                          <div className="col-lg-6">
                            <div className="shop-vid">
                              <iframe
                                className="product-details-vid"
                                src={selectedProduct?.video}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              ></iframe>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            {/* FICHE TECHNIQUE */}

                            <div className="wpo-project-single-content-des-right">
                              <ul className="ul-ficheTechnique">
                                {selectedProduct.ficheTechnique &&
                                  selectedProduct.ficheTechnique.map(
                                    (element) => (
                                      <li key={element.key}>
                                        <p>{element.key}</p>
                                        <span>{element.value}</span>
                                      </li>
                                    )
                                  )}
                              </ul>
                            </div>
                          </div>
                        </div>

                        {/* Technical features if they exists */}
                        {selectedProduct &&
                          selectedProduct.technicalFeatures &&
                          selectedProduct.technicalFeatures.length > 0 && (
                            <div className="row technical_features">
                              {selectedProduct.technicalFeatures.map((item) => {
                                return (
                                  <>
                                    <h3 className="technical_features_h3">
                                      {" "}
                                      {item.type}
                                    </h3>
                                    {item.features.map((el) => (
                                      <li className="col-2" key={el.key}>
                                        <p>{el.key}</p>
                                        <span>{el.value}</span>
                                      </li>
                                    ))}
                                  </>
                                );
                              })}
                            </div>
                          )}
                      </div>
                      <div className="tab-area">
                        <Devis selectedProduct={selectedProduct} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OtherDetails;
